// 旧项目的求求

import axios from 'axios'
import qs from 'qs'
// 在js中引入饿了吗的message的方式
import {Message} from 'element-ui';
import router from '../router'
import store from '@/store'

const url = store.state.IPAss.TP; // 本机测试 意义不大
// 创建axios实例
const service = axios.create({
  baseURL: url, // url = base url + request url
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  timeout: 120000,// request timeout
})
//请求拦截器
service.interceptors.request.use(config=>{
    //如果存在token，请求携带这个token
    if (window.sessionStorage.getItem('userIdStr')){
        config.headers['userIdStr'] = window.sessionStorage.getItem('userIdStr');
    }
    if (window.sessionStorage.getItem('Authorization')){
        config.headers['Authorization'] = window.sessionStorage.getItem('Authorization');
    }
    return config;
},error => {
    console.log(error);
})


/* ---------------------------------------------------------------------------
 * 只读请求的自动重试
 * ---------------------------------------------------------------------------
 * 背景：字典/下拉选项这类数据是"进页面只取一次"，一旦这一次请求抖动（网络错误、
 *       超时、服务端瞬时 5xx），页面里 `if (resp)` 就永远不成立 —— 下拉空着，
 *       而且用户要"切走再回来"才会重新请求。这里在公共层给只读请求补 1~2 次
 *       静默重试，抖动基本能自愈，页面代码不用改。
 * 安全边界：
 *   1) 只重试**只读**请求：method=get，或 url 命中字典接口 `/dim/`（这两个都不会写库）；
 *      POST/PUT/DELETE 的写请求**绝不重试**，避免"其实写成功了但响应丢了"导致重复写入；
 *   2) 401/403/300 不重试（重试也没意义，属于权限/登录问题）；
 *   3) 重试不弹提示，只在 console 留痕，避免打扰用户。
 * ------------------------------------------------------------------------- */
const READ_ONLY_RETRY_MAX = 2;          // 最多重试 2 次
const READ_ONLY_RETRY_DELAY = [800, 2500]; // 每次重试前的等待毫秒数

function isReadOnlyRequest(config) {
    if (!config) return false;
    const method = (config.method || '').toLowerCase();
    const url = config.url || '';
    return method === 'get' || url.indexOf('/dim/') !== -1;
}

// 返回一个 promise 表示"稍后重试"，不需要重试时返回 null
function scheduleRetry(config) {
    const done = config.__retryCount || 0;
    if (done >= READ_ONLY_RETRY_MAX) return null;
    config.__retryCount = done + 1;
    const delay = READ_ONLY_RETRY_DELAY[Math.min(done, READ_ONLY_RETRY_DELAY.length - 1)];
    console.warn(`[api] 只读请求失败，${delay}ms 后第 ${config.__retryCount} 次重试：${config.url || ''}`);
    return new Promise(resolve => {
        setTimeout(() => resolve(service(config)), delay);
    });
}

//响应拦截器
service.interceptors.response.use(success => {
    const config = success.config || {};
    if (success.status && success.status == 200) {
        const data = success.data || {};
        if (data.code == 500 || data.code == 401 || data.code == 403 || data.code == 300 ) {
            // 500 可能是服务端瞬时故障：只读请求走重试；其余（含 401/403/300）直接按业务错误处理
            if (data.code == 500 && isReadOnlyRequest(config)) {
                const retry = scheduleRetry(config);
                if (retry) return retry;
            }
            console.error(`[api] 业务错误 code=${data.code} url=${config.url || ''} msg=${data.msg || ''}`);
            Message.error({message: data.msg});  // 业务逻辑错误
            return;
        }
		if (data.msg) {       //业务逻辑正常
		   Message.success({message: data.msg});
		}

    }
    return success.data;
}, error => {    // 接口失败
    const config = (error && error.config) || {};
    // 注意：这里以前写的是 error.response.code，axios 上是 error.response.status；
    // 而且网络错误/超时时 error.response 是 undefined，取 .code 会直接抛 TypeError，
    // 导致失败被静默吞掉（页面什么都不发生、也没有任何提示）。
    const status = error && error.response && error.response.status;
    const respMsg = error && error.response && error.response.data && error.response.data.msg;
    // 网络错误/超时/5xx：只读请求静默重试
    if (isReadOnlyRequest(config) && (!status || status >= 500)) {
        const retry = scheduleRetry(config);
        if (retry) return retry;
    }
    console.error(`[api] 请求失败 url=${config.url || ''} status=${status || '(无响应)'} msg=${respMsg || (error && error.message) || ''}`);
    if (status == 504 || status == 404) {
        Message.error({message: '服务器被吃了o(╯□╰)o'});
    } else if (status == 403) {
        Message.error({message: '权限不足，请联系管理员！'});
    } else if (status == 401) {
        Message.error({message: '尚未登录，请登录'});
        router.replace('/');
    } else {
        if (respMsg) {
            Message.error({message: respMsg});
        } else {
            Message.error({message: '未知错误！'});
        }
    }
    return;
});

let base = 'work';

//传送 json格式 的post请求
export const postRequest = (url, params) => {
    return service({
        method: 'post',
        url: `${base}${url}`,
        data: params
    })
}
export const postRequests = (url,params)=>{
    return service({
        method: 'post',
        url:`${base}${url}`,
        params:params
    })
}
export const needPost = (url, params) => {
    return service({
        method: 'post',
        url: `${base}${url}`,
        headers: {
            'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundaryMM6bBNTtziZenm2T'
        },
        data: params
    })
}

//传送 表单格式 的post请求   需要先安装: qs   qs.stringify()将对象 序列化成URL的形式以&进行拼接
export const postRequest2 = (url, params) => {
	// debugger
    return service({
        method: 'post',
        url: `${base}${url}`,
        data: qs.stringify(params)
    })
}

//传送json的put请求
export const putRequest=(url,params)=>{
    return service({
        method: 'put',
        url:`${base}${url}`,
        data:params
    })
}

//传送json的get请求
export const getRequest=(url,params)=>{
    return service({
        method: 'get',
        url:`${base}${url}`,
        data:params
    })
}

export const getRequests = (url,params)=>{
    return service({
        method: 'get',
        url:`${base}${url}`,
        params:params
    })
}


//传送json的delete请求
export const deleteRequest=(url,params)=>{
    return service({
        method: 'delete',
        url:`${base}${url}`,
        data:params
    })
}
